<template>
  <b-row>
    <b-col :cols="2"/>
    <b-col :cols="8">
      <b-card-group deck class="m-2">
        <b-card class="" header-tag="header" footer-tag="footer" style="width: inherit">
          <template v-slot:header>
            <h6 class="mb-0 text-center">Personal Information</h6>
          </template>
          <template>
            <span><strong style="color: #49a8e8">First Name:</strong> {{ user_data.first_name }}</span><br/><br/>
            <span><strong style="color: #49a8e8">Last Name:</strong> {{ user_data.last_name }}</span><br/><br/>
            <span><strong style="color: #49a8e8">Email:</strong> {{ user_data.email }}</span><br/><br/>
            <span><strong style="color: #49a8e8">Username:</strong> {{ user_data.username }}</span><br/><br/>
          </template>
        </b-card>
      </b-card-group>
    </b-col>
    <b-col :cols="2"/>
    <b-col :cols="2"/>
    <b-col :cols="8">
      <b-card-group deck class="m-2">
        <b-card class="" header-tag="header" footer-tag="footer" style="width: inherit">
          <template v-slot:header>
            <h6 class="mb-0 text-center">Company Information</h6>
          </template>
          <template>
            <span><strong style="color: #49a8e8">Company Name:</strong> {{ user_data.company_name }}</span><br/><br/>
            <span v-if="this.showAPIToken"><strong
              style="color: #49a8e8">API Token:</strong> {{ user_data.company_api_token }}</span>
            <span v-else><strong style="color: #49a8e8">API Token:</strong> <b>.........................</b></span>
            <b-button v-b-toggle.collapse-1 size="sm" variant="info" style="float: right"
                      @click="toggleAPIToken()">
              Show/Hide API Token
            </b-button>
            <br/><br/>
          </template>
        </b-card>
      </b-card-group>
    </b-col>
  </b-row>
</template>

<script>
import store from "@/store";

export default {
  data() {
    return {
      user_data: {},
      showAPIToken: false
    }
  },

  created() {
    this.user_data = store.state.general.user
  },
  methods: {
    toggleAPIToken() {
      this.showAPIToken = (!this.showAPIToken);
    }
  }
}
</script>
